module.exports = __webpack_public_path__ + "static/media/1-6.16aa4e3d.mp3";